import axios from 'axios';

// تعيين الـ baseURL هنا
axios.defaults.baseURL = 'https://api.van-graph.com/api/';
axios.defaults.withCredentials = true;
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';



export default axios;
